import { Icon } from '@iconify/react';
import { useLoginDrawer } from '@/contexts/LoginDrawerContext';

export function GuestLoginBanner() {
  const { openLoginDrawer } = useLoginDrawer();

  return (
    <div
      data-testid="guest-login-banner"
      className="rounded-2xl bg-[#FDE8D8] px-4 py-3.5 flex items-center gap-3"
    >
      <div className="w-11 h-11 rounded-full bg-white/80 flex items-center justify-center flex-shrink-0">
        <Icon icon="ph:user" className="w-6 h-6 text-[#FC480D]" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-[#0E1726] leading-snug">Masuk untuk bergabung</p>
        <p className="text-xs text-[#4B5563] leading-snug mt-0.5">
          Gabung event, booking lapangan, dan catat statistikmu.
        </p>
      </div>
      <button
        type="button"
        onClick={openLoginDrawer}
        className="flex-shrink-0 rounded-xl bg-[#FC480D] text-white text-sm font-semibold px-4 py-2 active:scale-95 transition-transform"
      >
        Masuk
      </button>
    </div>
  );
}

export default GuestLoginBanner;
